module.exports = __webpack_public_path__ + "img/dr-strange.e31367c3.png";